import { makeStyles } from "tss-react/mui";

export default makeStyles({ name: "AllData" })((theme) => ({
  page: {
    margin: "20px",
  },
}));
